import ApiService from "@/common/api.service";
import {
  SUBNOTE_DOWNLOAD
} from "./actions.type";

const actions = {
  [SUBNOTE_DOWNLOAD](context, subnoteData) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.getBlob("subnotes/" + subnoteData.id + "/download/")
        .then(({ data }) => {
          resolve(data);
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          let url = window.URL.createObjectURL(blob);
          let hiddenA = document.createElement("a");
          document.body.appendChild(hiddenA);
          hiddenA.style = "display: none";
          hiddenA.href = url;
          hiddenA.download = subnoteData.name + '.docx';
          hiddenA.click();
          window.URL.revokeObjectURL(url);
        });
    });
  }
}

export default {
  actions
};